export default __webpack_public_path__ + "static/media/heart-outline.636a6f84.svg";